import { Layout } from '@/components/Layout';

export default function Privacy() {
  return (
    <Layout>
      <div className="container mx-auto px-6 md:px-12 py-12 max-w-4xl" data-testid="privacy-page">
        <h1 className="text-5xl md:text-6xl font-heading font-bold mb-8">PRIVACY POLICY</h1>
        <p className="text-sm text-muted-foreground mb-8">Last Updated: February 2026</p>
        
        <div className="space-y-8 text-muted-foreground leading-relaxed">
          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">1. Information We Collect</h2>
            <p className="mb-4">When you visit PrimeStatLab, we may collect:</p>
            <ul className="list-disc ml-6 space-y-2">
              <li>Usage data (pages visited, time spent, device information)</li>
              <li>Email address (if you contact us or subscribe)</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">2. How We Use Your Information</h2>
            <p className="mb-4">We use collected information to:</p>
            <ul className="list-disc ml-6 space-y-2">
              <li>Provide and improve our services</li>
              <li>Respond to inquiries and support requests</li>
              <li>Send updates about picks and analysis (if subscribed)</li>
              <li>Analyze site usage and optimize user experience</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">3. Data Sharing and Disclosure</h2>
            <p className="mb-4">We do NOT sell your personal information. We may share data with:</p>
            <ul className="list-disc ml-6 space-y-2">
              <li>Service providers who help operate our site</li>
              <li>Analytics platforms (Google Analytics, etc.)</li>
              <li>Legal authorities if required by law</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">4. Third-Party Links</h2>
            <p>
              Our site contains links to third-party sportsbooks and services. We are not responsible for their privacy practices. 
              Please review their policies before providing personal information.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">5. Cookies</h2>
            <p className="mb-4">
              We use cookies to enhance your experience. You can disable cookies in your browser settings, but this may affect site functionality.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">6. Data Security</h2>
            <p>
              We implement reasonable security measures to protect your information. However, no method of transmission over the internet is 100% secure.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">7. Children's Privacy</h2>
            <p>
              Our services are not intended for individuals under 18. We do not knowingly collect information from minors.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">8. Your Rights</h2>
            <p className="mb-4">You have the right to:</p>
            <ul className="list-disc ml-6 space-y-2">
              <li>Access your personal data</li>
              <li>Request correction or deletion</li>
              <li>Opt-out of marketing communications</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">9. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated date.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">10. Contact Us</h2>
            <p>
              For privacy-related questions, contact us at: <a href="mailto:primestatlab@gmail.com" className="text-primary hover:underline">primestatlab@gmail.com</a>
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
}